import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Card, Row, Col, Divider, Checkbox } from "antd";
import { IGuest } from "../../interfaces";
import { combineAddress } from "../../utils/addressUtils";

const { TextArea } = Input;

export const GuestCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<IGuest>({
    onMutationSuccess: (data) => {
      console.log("Guest created successfully:", data);
    },
  });

  // Override the form's onFinish to transform data before submission
  const modifiedFormProps = {
    ...formProps,
    onFinish: (values: any) => {
      // Kombiniere Straße und Hausnummer für Backwards Compatibility
      const personalAddress = combineAddress(values.street || '', values.housnr || '');

      const transformedData: Partial<IGuest> = {
        ...values,
        address: personalAddress,
      };

      console.log("Submitting Guest Data:", transformedData);
      
      // Call the original onFinish with transformed data
      formProps.onFinish?.(transformedData);
    },
  };

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...modifiedFormProps} layout="vertical">
        <Row gutter={[16, 16]}>
          {/* Persönliche Daten */}
          <Col span={24}>
            <Card title="Persönliche Daten" size="small">
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Anrede"
                    name="gender"
                  >
                    <Input placeholder="Herr/Frau" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Vorname" name="firstname">
                    <Input placeholder="Vorname" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Nachname" name="lastname">
                    <Input placeholder="Nachname" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="E-Mail"
                    name="email"
                    rules={[
                      { required: true, message: "Bitte E-Mail eingeben" },
                      { type: "email", message: "Bitte gültige E-Mail eingeben" }
                    ]}
                  >
                    <Input placeholder="email@example.com" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Mobile" name="mobile">
                    <Input placeholder="+49 123 456789" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Straße" name="street">
                    <Input placeholder="Straßenname" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Hausnummer" name="housnr">
                    <Input placeholder="Nr." />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="PLZ" name="zip">
                    <Input placeholder="12345" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Ort" name="city">
                    <Input placeholder="Stadt" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Land" name="country">
                    <Input placeholder="Deutschland" defaultValue="Deutschland" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>

          {/* Firmendaten (optional) */}
          <Col span={24}>
            <Card title="Firmendaten (optional)" size="small">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Firmenname" name="company">
                    <Input placeholder="Firmenname" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="USt-IdNr" name="company_tax_id">
                    <Input placeholder="USt-IdNr (falls vorhanden)" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="business_account" valuePropName="checked">
                    <Checkbox>Geschäftlicher Account</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>

          {/* Notizen */}
          <Col span={24}>
            <Card title="Notizen" size="small">
              <Form.Item label="Interne Notizen" name="notes">
                <TextArea 
                  rows={4} 
                  placeholder="Interne Notizen zum Gast (z.B. Präferenzen, Besonderheiten, etc.)" 
                />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
}; 